/**
 * Cart Buy-Now Tracker
 *
 * Sets a cart attribute `_has_buy_now_items` when buy-now items are present.
 * Uses the "Fulfillment Method" line item property (set by the shipping
 * confirmation modal) as a proxy for buy-now product detection.
 *
 * This attribute is useful for:
 * - Order tagging automation (Mechanic, Shopify Flow)
 * - Checkout extensibility / delivery customization functions
 * - Analytics tracking
 */
(function () {
  'use strict';

  async function updateBuyNowCartAttribute() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: { Accept: 'application/json' },
      });
      const cart = await response.json();

      // Check if any item has the "Fulfillment Method" property
      // (set by the shipping confirmation modal for buy-now products)
      let hasBuyNow = false;
      for (const item of cart.items) {
        if (item.properties && item.properties['Fulfillment Method']) {
          hasBuyNow = true;
          break;
        }
      }

      // Only update if the attribute value has changed
      const currentAttr =
        cart.attributes && cart.attributes['_has_buy_now_items'];
      const newValue = hasBuyNow ? 'true' : '';

      if (currentAttr !== newValue) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              _has_buy_now_items: newValue,
            },
          }),
        });
      }
    } catch (e) {
      // Fail silently -- this is a non-critical enhancement
    }
  }

  // Run on page load
  updateBuyNowCartAttribute();

  // Run after cart changes (events dispatched by cart.js and cart-drawer.js)
  document.addEventListener('afterCartChanged', updateBuyNowCartAttribute);
  document.addEventListener('afterUpdateQuantity', updateBuyNowCartAttribute);
})();
